import { Injectable } from "@angular/core";
import { Validators } from "@angular/forms";
import { BaseControl, TextArea } from "@app/shared";

@Injectable()
export class AnnulationProcessFormService{
  constructor() { }
  
  /**
   *Configuración del formulario de anulación
   *
   * @param {*} [objectModel]
   * @return {*}  {BaseControl<any>[]}
   * @memberof AnnulationProcessFormService
   */
  getForm(objectModel?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new TextArea({
        key: 'textarea',
        label: 'Motivo de anulación:',
        rows: '2',
        notResize: true,
        value: objectModel ? objectModel.motivo : null,
        order: 1,
        validations: {
          validators: [Validators.required]
        }
      })
    ];
    return controls.sort((a, b) => a.order - b.order);
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/annulation-process/shared/annulation-process.form.service.ts